import { useState } from 'react';

import useToggleable from '../../hooks/use-toggleable';

const useToggleSideRail = actionPrefix => {
  const { isOn, on, off, toggle } = useToggleable({ actionPrefix });
  return { isVisible: isOn, show: on, hide: off, toggle };
};

const TABS = {
  disclosures: 'disclosures',
  glossary: 'glossary',
  tagDefinitions: 'tagDefinitions'
};

const TAB_DEFAULT = TABS.glossary;

const useSideRail = () => {
  const toggleDisclosures = useToggleSideRail('DISCLOSURES');
  const toggleGlossary = useToggleSideRail('GLOSSARY');
  const toggleTagDefinitions = useToggleSideRail('TAGDEFINITIONS');

  const [tabActive, setTabActive] = useState(TAB_DEFAULT);
  const [scrollToModule, setScrollToModule] = useState();

  const isVisible =
    toggleDisclosures.isVisible || toggleGlossary.isVisible || toggleTagDefinitions.isVisible;

  const show = () => {
    if (tabActive === TABS.disclosures) {
      toggleDisclosures.show();
    } else if (tabActive === TABS.glossary) {
      toggleGlossary.show();
    } else {
      toggleTagDefinitions.show();
    }
  };

  const hide = () => {
    toggleDisclosures.hide();
    toggleGlossary.hide();
    toggleTagDefinitions.hide();
    setScrollToModule();
  };

  return {
    TABS,
    disclosures: {
      hide,
      isVisible: toggleDisclosures.isVisible,
      show(_module) {
        setTabActive(TABS.disclosures);
        toggleDisclosures.show();
        toggleGlossary.hide();
        toggleTagDefinitions.hide();
        if (_module) setScrollToModule(_module);
      }
    },
    glossary: {
      hide,
      isVisible: toggleGlossary.isVisible,
      show(_module) {
        setTabActive(TABS.glossary);
        toggleDisclosures.hide();
        toggleGlossary.show();
        toggleTagDefinitions.hide();
        if (_module) setScrollToModule(_module);
      }
    },
    tagDefinitions: {
      hide,
      isVisible: toggleTagDefinitions.isVisible,
      show() {
        setTabActive(TABS.tagDefinitions);
        toggleTagDefinitions.show();
        toggleDisclosures.hide();
        toggleGlossary.hide();
      }
    },
    hide,
    isVisible,
    scrollToModule,
    show,
    tabActive,
    toggle() {
      isVisible ? hide() : show();
    }
  };
};

export default useSideRail;
